import React from 'react';
import { Flex, Typography } from 'antd';

import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

const { Text } = Typography;

export const LegalInfo = () => {
    const { legal_info } = useAppSelector(selectShopCurrent);

    return (
        <>
            <Text>
                Данные автоматически обновляются каждые 24 часа, согласно данным
                на сайте WB.
            </Text>
            <Flex style={{ marginTop: '16px' }} vertical>
                {legal_info.id && <Text>ID WB магазина: {legal_info.id}</Text>}
                {legal_info.name && <Text>Название: {legal_info.name}</Text>}
                <Flex vertical={false} gap={8}>
                    {legal_info.inn && <Text>ИНН {legal_info.inn}</Text>}
                    {legal_info.kpp && <Text>КПП {legal_info.kpp}</Text>}
                    {legal_info.ogrn && <Text>ОГРН {legal_info.ogrn}</Text>}
                </Flex>
                {legal_info.address && <Text> {legal_info.address}</Text>}
            </Flex>
        </>
    );
};
